/**
 * Checks for a numeric match within a certain tolerance.
 *
 * @param {number} value1
 * @param {number} value2
 * @param {number} tolerance
 */
export function checkMatch(value1, value2, tolerance) {
    return value1 - tolerance <= value2 && value2 <= value1 + tolerance;
}
//# sourceMappingURL=checkMatch.js.map